import { useEffect } from 'react';

import type { NHeaderProvider } from '@app/providers/HeaderProvider/HeaderProvider.types';

import type { Dispatch, SetStateAction } from 'react';

interface UseCertificatesEffectsProps {
  setHeader: Dispatch<SetStateAction<NHeaderProvider.Header>>;
  openCreateModal: () => void;
  page: number;
  clampedPage: number;
  setPage: Dispatch<SetStateAction<number>>;
}

export const useCertificatesEffects = ({
  setHeader,
  openCreateModal,
  page,
  clampedPage,
  setPage,
}: UseCertificatesEffectsProps): void => {
  useEffect(() => {
    setHeader({ openCertificateModal: openCreateModal });
  }, [setHeader, openCreateModal]);

  // После удаления список может стать короче — без этого при росте списка
  // таблица вернулась бы на старую страницу
  useEffect(() => {
    if (clampedPage !== page) {
      setPage(clampedPage);
    }
  }, [clampedPage, page, setPage]);
};
